import React, { useState } from 'react';
import { Label, TextInput } from 'flowbite-react';
import Select, { MultiValue } from 'react-select';
import { PreInterviewsFormData } from 'types';
import { Dropdown, expectedJoiningOptions, gradYearOptions, locationPreferenceOptions } from 'shared-utils';
import { checkMinMaxValidity } from 'src/utils/interview';
import { pifChangableFieldsConfig } from 'src/utils/pifConfig';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	formData: Partial<PreInterviewsFormData>;
	setFormData: (arg: Partial<PreInterviewsFormData>) => void;
	isValid: Boolean;
	setIsValid: (arg: Boolean) => void;
}

const FormIfWorking = ({ formData, setFormData, isValid, setIsValid }: Props) => {
	let locationTimeoutId: NodeJS.Timeout | undefined;
	const { user } = useUserContext();
	const [isMoreThanFiveLocationSelected, setIsMoreThanFiveLocationSelected] = useState<boolean>(false);
	const handleLoactionPreferences = (value: MultiValue<Dropdown>) => {
		const selectedLocation = value.map(item => item.value);
		if (selectedLocation.length <= 5) {
			setIsMoreThanFiveLocationSelected(false);
			setFormData({
				...formData,
				preferredJobLocations: selectedLocation,
			});
		} else {
			setIsMoreThanFiveLocationSelected(true);
			if (locationTimeoutId) {
				clearTimeout(locationTimeoutId); // Clear the previous timeout
			}
			locationTimeoutId = setTimeout(() => {
				setIsMoreThanFiveLocationSelected(false);
			}, 3000);
		}
	};
	return (
		<div className="flex flex-col gap-4">
			<div className="mt-2 font-inter">
				<Label>
					Graduation Year <span className="text-red-600">*</span>
				</Label>
				<Select
					isDisabled={pifChangableFieldsConfig.graduationYear === false && user?.profile.gradYear ? true : false}
					menuPlacement={'auto'}
					className="single-value-select-tag !max-w-[500px]"
					classNamePrefix="my-select-plans"
					instanceId="workingGradYear"
					closeMenuOnSelect
					options={gradYearOptions}
					value={gradYearOptions.find(item => Number(item.value) === formData.graduationYear)}
					onChange={value => {
						if (value) {
							setFormData({
								...formData,
								graduationYear: Number(value.value),
							});
						}
					}}
				/>
			</div>

			<div className="mt-2 flex gap-3 font-inter">
				<div>
					<Label>
						Current Company <span className="text-red-600">*</span>
					</Label>
					<TextInput
						disabled={
							pifChangableFieldsConfig?.currentCompany === false && user?.profile?.currentCompany !== undefined
								? true
								: false
						}
						style={{
							fontFamily: "'Inter', sans-serif",
							fontSize: '14px',
							width: '500px',
						}}
						onChange={e => setFormData({ ...formData, currentCompany: e.target.value })}
						value={formData.currentCompany}
						placeholder="Masai School"
					/>
				</div>
				<div>
					<Label>
						Current Role <span className="text-red-600">*</span>
					</Label>
					<TextInput
						disabled={
							pifChangableFieldsConfig?.currentRole === false && user?.profile?.currentRole !== undefined ? true : false
						}
						style={{
							fontFamily: "'Inter', sans-serif",
							fontSize: '14px',
							width: '500px',
						}}
						onChange={e => setFormData({ ...formData, currentRole: e.target.value })}
						value={formData.currentRole}
						placeholder="Full Stack Developer"
					/>
				</div>
			</div>

			<div className="flex gap-3 font-inter">
				<div>
					<Label>
						Current Salary (in LPA) <span className="text-red-600">*</span>
					</Label>
					<TextInput
						disabled={
							pifChangableFieldsConfig?.currentSalary === false && user?.profile?.currentSalary !== undefined
								? true
								: false
						}
						style={{
							fontFamily: "'Inter', sans-serif",
							fontSize: '14px',
							width: '500px',
						}}
						type="number"
						min={0}
						max={99}
						onChange={e => setFormData({ ...formData, currentSalary: Number(e.target.value) })}
						value={formData.currentSalary}
						placeholder="12"
					/>
				</div>
				<div className="w-full">
					<Label>
						Expected Joining <span className="text-red-600">*</span>
					</Label>
					<Select
						isDisabled={
							pifChangableFieldsConfig?.expectedJoining === false && user?.profile?.expectedJoining !== undefined
								? true
								: false
						}
						menuPlacement={'auto'}
						className="single-value-select-tag !max-w-[500px]"
						classNamePrefix="my-select-plans"
						instanceId="workingExpectedJoining"
						closeMenuOnSelect
						options={expectedJoiningOptions}
						value={expectedJoiningOptions?.find(item => item.value === formData.expectedJoining)}
						onChange={value => {
							if (value) {
								setFormData({
									...formData,
									expectedJoining: value?.value,
								});
							}
						}}
						placeholder="within a month"
					/>
				</div>
			</div>

			<div className="mt-2 font-inter">
				<div className="mt-2 font-inter">
					<Label>
						Preferred Location (upto 5 locations) <span className="text-red-600">*</span>
					</Label>
				</div>
				{isMoreThanFiveLocationSelected ? (
					<p className="font-inter text-[12px] text-red-700">You can only Select upto 5 locations</p>
				) : null}
				<Select
					isDisabled={
						pifChangableFieldsConfig?.preferredJobLocations === false &&
						user?.profile?.preferredJobLocations !== undefined &&
						user?.profile?.preferredJobLocations?.length > 0
							? true
							: false
					}
					menuPlacement={'auto'}
					className="!max-w-[500px]"
					classNamePrefix="my-select-plans"
					instanceId="location_preference"
					menuPosition="fixed"
					isMulti={true}
					placeholder={'Select your prefered locations'}
					value={locationPreferenceOptions
						?.filter(location => formData.preferredJobLocations?.includes(location))
						.map(location => ({ value: location, label: location }))}
					closeMenuOnSelect={false}
					options={locationPreferenceOptions.map(location => ({ value: location, label: location }))}
					onChange={handleLoactionPreferences}
				/>
			</div>
		</div>
	);
};

export default FormIfWorking;
